import AccordionText from "../Utils/AccordionText"
import Attribute from "./Attribute"
import { CustomVariantItemProps, ProductDetailItemProps, ProductVariantItemProps, PromotionItemProps } from "./constants"
import { useEffect, useRef, useState } from "react";
import Image from 'next/image';
import SizeGuide from "./SizeGuide";
import { useAttributesStore } from "@/stores/useAttributesStore";
import Cookies from "js-cookie";
import { get_original_price, get_sales_price } from "@/lib/Definitions";
import ReactPlayer from 'react-player/youtube';
import Link from "next/link";
import RightSideDialog from "../Utils/RightSideDialog";
import VideoPlayer from "./VideoPlayer";


interface ProductDetailWithAttrProps extends ProductDetailItemProps {
  setVariantId: (setVariantId: number) => void;
  setOpen: (open: boolean) => void;
  variant: ProductVariantItemProps | null;
  setVariant: (variant: ProductVariantItemProps | null) => void;
  firstVariant: ProductVariantItemProps | null;
  selectedCustomVariant: CustomVariantItemProps | null;
  setSelectedCustomVariant: (variant: CustomVariantItemProps | null) => void;
  fromName: string;
  setFromName: (value: string) => void;
  toName: string;
  setToName: (value: string) => void;
  toEmail: string;
  setToEmail: (value: string) => void;
  toMobile: string;
  setToMobile: (value: string) => void;
  toMessage: string;
  setToMessage: (value: string) => void;
  pregnancy: string;
  setPregnancy: (value: string) => void;
  duDate: Date | null;
  setDuDate: (value: Date | null) => void;
  childName: string;
  setChildName: (value: string) => void;
  childAge: number | null;
  setChildAge: (value: number | null) => void;
  childGender: string;
  setChildGender: (value: string) => void;
  sharedSalesPrice: number;
  affiliate: string | undefined;
  setClickAttribute: (value: boolean) => void;
  setSelectColor: (color: number) => void;
}

const Detail = (props: ProductDetailWithAttrProps) => {
  const viewport = Cookies.get('viewport');
  const { attributes, getAttributes } = useAttributesStore();
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [attributesData, setAttributesData] = useState(getAttributes());
  const [videoHeight, setVideoHeight] = useState(0);
  const videoRef = useRef<HTMLDivElement>(null);
  const [promoteOpen, setPromoteOpen] = useState(false);
  const [promoteTitle, setPromoteTitle] = useState<JSX.Element | null>(null);
  const [promoteContent, setPromoteContent] = useState<JSX.Element | null>(null);
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [affiliateDiscountPercent, setAffiliateDiscountPercent] = useState<number>(0);
  const [videoUrl, setVideoUrl] = useState<string>("");

  useEffect(() => {
    if (videoRef.current !== null) {
      setVideoHeight(videoRef.current.offsetWidth * 0.5625);
    }
  }, [])

  useEffect(() => {
    if (props.video_list && props.video_list.length > 0) {
      setVideoUrl(props.video_list[0]);
    }
  }, [props.video_list])

  const show_add_to_cart = () => {
    if (props.variant !== null && props.variant !== undefined && props.variant.qty > 0) {
      props.setOpen(true);
    } else {
      props.setVariant(props.firstVariant);
      props.setOpen(true);
    }
  }

  const displaySizeGuide = () => {
    setShowSizeGuide(true);
  }

  const handleShowPromotion = (promo: PromotionItemProps) => {
    let promoteImage = null;

    switch (promo.type) {
      case "discount":
      case "cashback":
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-discount-cashback.png";
        break;

      case "free-shipping":
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-free-shipping.png";
        break;

      case "gift":
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-free-gift.png";
        break;

      default:
        promoteImage = process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/promo-special.png";
    }

    setPromoteTitle(
      <div className="flex items-center space-x-2 font-poppins">
        <Image
          src={promoteImage}
          alt="promotion icon"
          width={28}
          height={28}
          quality={100}
        />
        <p className="text-sm font-bold text-black">{promo.name}</p>
      </div>
    )

    setPromoteContent(
      <div className="font-poppins">
        <p className="my-4 text-sm text-black">Giai đoạn : {promo.start_date} - {promo.end_date}</p>
        <p className="text-base font-bold text-black">ĐIỀU KHOẢN & ĐIỀU KIỆN :</p>
        <p className="my-4 text-sm text-black">{promo.description}</p>
        <ul className="pl-5 text-sm text-black list-disc list-outside">
          {promo.free_shipping && (
            <li className="my-4">Nhận được giảm giá vận chuyển {promo.shipping_charge?.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}</li>
          )}
          {promo.gift && (
            <li className="my-4">Nhận một món quà MIỄN PHÍ dưới dạng {promo.gift.replace(`&apos;`, `'`)} mỗi lần mua hàng</li>
          )}
          {promo.minimum_amount && promo.minimum_amount > 0 && (
            <li className="my-4">Khuyến mãi áp dụng cho mọi đơn hàng có giá trị mua tối thiểu {promo.minimum_amount.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}</li>
          )}
          {promo.membership_level && (
            <li className="my-4">Khuyến mãi chỉ áp dụng cho một số cấp độ nhất định</li>
          )}
          <li className="my-4">Khuyến mãi chỉ có hiệu lực trên trang web MOOIMOM</li>
          {promo.gift && (
            <li className="my-4">Khuyến mãi có hiệu lực cho đến khi hết hàng</li>
          )}
        </ul>
      </div>
    );

    setPromoteOpen(true);
  }

  useEffect(() => {
    setAttributesData(getAttributes());
  }, [getAttributes, attributes])

  useEffect(() => {
    if (props.variant === null || props.variant === undefined) {
      props.setVariantId(0);
    } else {
      props.setVariantId(props.variant.variant_id);
    }
  }, [props.variant])

  const show_sales_price = () => {
    const sales_price = get_sales_price(props, props.variant);

    if (Array.isArray(sales_price.price)) {
      return (
        <p className={`flex text-xl text-price`}>
          {sales_price.price[0].toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY} ~ {sales_price.price[1].toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    } else {
      return (
        <p className={`flex text-xl ${sales_price.promotion ? "text-mooimom" : "text-price"}`}>
          {sales_price.price.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    }
  }

  const show_origin_price = () => {
    const origin_price = get_original_price(props, props.variant);

    if (origin_price === null) {
      return (<></>)
    } else {
      return (
        <p className="text-sm line-through text-originPrice">
          {origin_price.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    }
  }

  const show_affiliate_origin_price = () => {
    const origin_price = get_original_price(props, props.variant);

    if (origin_price === null) {
      const sales_price = get_sales_price(props, props.variant);

      if (Array.isArray(sales_price.price)) {
        return (
          <p className="text-sm line-through text-originPrice">
            {sales_price.price[1].toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
          </p>
        )
      } else {
        return (
          <p className="text-sm line-through text-originPrice">
            {sales_price.price.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
          </p>
        )
      }
    } else {
      return (
        <p className="text-sm line-through text-originPrice">
          {origin_price.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
        </p>
      )
    }
  }

  useEffect(() => {
    const sales_price = get_sales_price(props, props.variant);
    const origin_price = get_original_price(props, props.variant);

    let salesPrice = 0;
    let originPrice = 0;

    if (!Array.isArray(sales_price.price)) {
      salesPrice = sales_price.price;
    }

    if (origin_price !== null) {
      originPrice = origin_price;
    }

    if (originPrice > 0 && salesPrice > 0) {
      setDiscountPercent(Math.round((originPrice - salesPrice) / originPrice * 100));
    } else if (Array.isArray(sales_price.price)) {
      setDiscountPercent(-1);
    } else {
      setDiscountPercent(0);
    }

    if (props.sharedSalesPrice > 0) {
      if (originPrice > 0) {
        setAffiliateDiscountPercent(Math.round((originPrice - props.sharedSalesPrice) / originPrice * 100));
      } else if (salesPrice > 0) {
        setAffiliateDiscountPercent(Math.round((salesPrice - props.sharedSalesPrice) / salesPrice * 100));
      } else if (Array.isArray(sales_price.price)) {
        setAffiliateDiscountPercent(-1);
      } else {
        setAffiliateDiscountPercent(0);
      }
    }
  }, [props, props.variant, props.sharedSalesPrice])

  const generate_how_to_use = () => {
    return props.how_to_use.map((use, index) => {
      if (use.title !== "" && use.description !== "") {
        return (
          <div key={index}>
            <p className="font-bold">{use.title}</p>
            <p className="font-normal">{use.description}</p>
          </div>
        );
      } else if (use.title !== "" && use.document !== "") {
        return (
          <div key={index}>
            <Link href={use.document} className="underline text-mooimom">
              {use.title}
            </Link>
          </div>
        );
      } else if (use.video_link !== "") {
        return (
          <div key={index} className="w-full" ref={videoRef}>
            <ReactPlayer
              url={use.video_link}
              width="100%"
              height={videoHeight}
              playing={false}
              loop={true}
              controls={true}
              muted={true}
            />
          </div>
        );
      } else {
        return (<></>);
      }
    });
  }

  return (
    <>
      <div className={`mt-6 md:mt-0 font-poppins col-span-1 md:col-span-6`}>
        <div className={viewport === "desktop" ? "" : "container"}>
          <div className="text-xs font-bold text-attributeBorder">{props.brand}</div>
          <hr className="bg-attributeBorder w-[65px] mt-1" />
          <h1 className="mt-4 text-base font-bold text-black capitalize md:text-2xl md:mt-2">{props.name}</h1>
          <div className="hidden mt-2 text-xs md:block text-sku">{props.product_code}</div>
          {props.sharedSalesPrice === 0 && (
            <>
              <div className="flex items-center mt-2 space-x-2 font-bold">
                {show_sales_price()}
                {show_origin_price()}
              </div>
              {discountPercent === -1 && (
                <div className="flex items-center mt-2 border border-solid border-price flex-nowrap w-fit">
                  <div className="p-2 text-xs font-bold bg-white">
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/package-red.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                  <div className="flex items-center p-2 space-x-2 bg-price">
                    <p className="text-xs font-medium text-white">Giá đặc biệt cho trang web</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/discount-white.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              )}
              {discountPercent > 0 && (
                <div className="flex items-center mt-2 border border-solid border-price flex-nowrap w-fit">
                  <p className="text-xs font-bold bg-white text-price py-2 px-4 min-w-[78px]">{discountPercent}% Off</p>
                  <div className="flex items-center p-2 space-x-2 bg-price">
                    <p className="text-xs font-medium text-white">Giá đặc biệt cho trang web</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/discount-white.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {props.sharedSalesPrice > 0 && (
            <>
              <div className="flex items-center mt-2 space-x-2 font-bold">
                <p className={`flex text-xl text-affiliatePrice`}>
                  {props.sharedSalesPrice.toLocaleString()}{process.env.NEXT_PUBLIC_CURRENCY}
                </p>
                {show_affiliate_origin_price()}
              </div>
              {affiliateDiscountPercent === -1 && (
                <div className="flex items-center mt-2 border border-solid border-affiliatePrice flex-nowrap w-fit">
                  <div className="p-2 text-xs font-bold bg-white">
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/package-green.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                  <div className="flex items-center p-2 space-x-2 bg-affiliatePrice">
                    <p className="text-xs font-medium text-white">Giá liên kết đặc biệt</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/discount-white.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              )}
              {affiliateDiscountPercent > 0 && (
                <div className="flex items-center mt-2 border border-solid border-affiliatePrice flex-nowrap w-fit">
                  <p className="text-xs font-bold bg-white text-affiliatePrice py-2 px-4 min-w-[78px]">{affiliateDiscountPercent}% Off</p>
                  <div className="flex items-center p-2 space-x-2 bg-affiliatePrice">
                    <p className="text-xs font-medium text-white">Giá liên kết đặc biệt</p>
                    <Image
                      src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/discount-white.png"}
                      alt="special price icon"
                      quality={100}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {props.selling_points.length > 0 && (
          <>
            <hr className="my-6 bg-reviewBg" />
            <div className={viewport === "desktop" ? "" : "container"}>
              <ul className="pl-5 text-sm font-normal leading-8 text-black list-disc list-outside font-poppins">
                {props.selling_points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </>
        )}
        {props.attribute_value_list.length > 0 && (<hr className="my-6 bg-reviewBg" />)}
        <div className={viewport === "desktop" ? "" : "container"}>
          <Attribute
            product_code={props.product_code}
            attribute_value_list={props.attribute_value_list}
            product_variant_list={props.product_variant_list}
            attributes={attributesData.data}
            style="normal"
            variant={props.variant}
            setVariant={props.setVariant}
            virtual_product={props.virtual_product}
            need_shipping={props.need_shipping}
            custom_variant_list={props.custom_variant_list}
            selectedCustomVariant={props.selectedCustomVariant}
            setSelectedCustomVariant={props.setSelectedCustomVariant}
            fromName={props.fromName}
            setFromName={props.setFromName}
            toName={props.toName}
            setToName={props.setToName}
            toEmail={props.toEmail}
            setToEmail={props.setToEmail}
            toMobile={props.toMobile}
            setToMobile={props.setToMobile}
            toMessage={props.toMessage}
            setToMessage={props.setToMessage}
            pregnancy={props.pregnancy}
            setPregnancy={props.setPregnancy}
            duDate={props.duDate}
            setDuDate={props.setDuDate}
            childName={props.childName}
            setChildName={props.setChildName}
            childAge={props.childAge}
            setChildAge={props.setChildAge}
            childGender={props.childGender}
            setChildGender={props.setChildGender}
            setClickAttribute={props.setClickAttribute}
            setSelectProductColor={props.setSelectColor}
            use_product_option={props.use_product_option}
          />
        </div>
        {props.variant !== null && props.variant !== undefined && props.variant.qty === 0 && (
          <div className={`my-4 text-base italic leading-9 text-promotionPrice ${viewport === "desktop" ? "" : "container"}`}>Sản phẩm hết hàng</div>
        )}
        {((props.size_guide.category !== null && props.size_guide.category !== undefined) ||
          (props.size_guide.image !== null && props.size_guide.image !== undefined) ||
          (props.size_guide.measure !== null && props.size_guide.measure !== undefined) ||
          (props.size_guide.suggestion !== null && props.size_guide.suggestion !== undefined)) && (
          <div className={viewport === "desktop" ? "" : "container"}>
            <button
              className="flex p-2 mt-6 shadow-md bg-sizeGuideBg"
              onClick={displaySizeGuide}
            >
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/size-guide.png"}
                alt="size guide icon"
                width={20}
                height={20}
                quality={100}
              />
              <p className="ml-2 text-sm text-black">Size Guide</p>
            </button>
          </div>
        )}
        <div
          className={`md:hidden z-10 fixed bottom-10 left-1/2 -translate-x-1/2 py-2 px-4 w-[200px] rounded-lg text-white text-sm font-poppins font-medium shadow-xl flex justify-center items-center space-x-2 ${props.variant !== null && props.variant !== undefined && props.variant.qty === 0 ? "bg-disabledBtn" : "bg-review cursor-pointer"}`}
          onClick={show_add_to_cart}
        >
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/cart-white.png"}
            alt="cart icon"
            quality={100}
            width={20}
            height={20}
          />
          <p>Thêm vào giỏ hàng</p>
        </div>
        <hr className="my-6 bg-reviewBg" />
        {props.promotion && props.promotion.length > 0 && (
          <div className={`${viewport === "desktop" ? "" : "container"}`}>
            <p className="mb-4 text-sm font-bold text-black">Promotions</p>
            <div className="ml-4 space-y-3">
            {props.promotion.map((promo, index) => (
              <div key={index}>
                <div
                  className="flex items-center w-full space-x-2 cursor-pointer"
                  onClick={() => handleShowPromotion(promo)}
                >
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + `/images/icons/${promo.type === "free-shipping" ? "free-shipping" : "gift"}.png`}
                    alt="promotion icon"
                    quality={100}
                    width={24}
                    height={24}
                    className="flex-none"
                  />
                  <p className="text-xs font-semibold text-black grow">{promo.name}</p>
                  <Image
                    src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/more-detail.png"}
                    alt="more detail icon"
                    quality={100}
                    width={20}
                    height={20}
                    className="flex-none md:hidden"
                  />
                  <p className="flex-none hidden text-xs text-black underline md:block">Xem chi tiết</p>
                </div>
              </div>
            ))}
            </div>
          </div>
        )}
        <div className={`${viewport === "desktop" ? "" : "container"} ${process.env.NEXT_PUBLIC_STYLE_OPTION === "A" ? "" : "md:hidden"}`}>
          {props.promotion && props.promotion.length > 0 && (<hr className="my-6 bg-reviewBg" />)}
          {props.description_list.map((desc, index) => (
            <div key={index}>
              {desc.title === "" ? (
                <AccordionText
                  title="mô tả"
                  title_style="text-black text-sm font-bold leading-8"
                  description={desc.description}
                  desc_style="font-normal text-sm text-black leading-8"
                  border={false}
                />
              ) : (
                <AccordionText
                  title={desc.title}
                  title_style="text-black text-sm font-bold leading-8"
                  description={desc.description}
                  desc_style="font-normal text-sm text-black leading-8"
                  border={true}
                />
              )}
            </div>
          ))}
          {props.how_to_use.length > 0 && (
            <AccordionText
              title="Instruksi Manual"
              title_style="text-black text-sm font-bold leading-8"
              description=""
              descriptionElement={generate_how_to_use()}
              desc_style="font-normal text-sm text-black leading-8"
              border={true}
            />
          )}
        </div>
        <SizeGuide
          size_guide={props.size_guide}
          isVisible={showSizeGuide}
          setIsVisible={setShowSizeGuide}
        />
      </div>
      <div className="hidden col-span-2 md:block border border-reviewBg rounded sticky py-4 px-3 top-[120px] h-fit">
        <button
          className={`w-full h-fit flex items-center justify-center space-x-2 py-1 px-2 text-white text-sm font-poppins font-normal rounded ${props.variant !== null && props.variant !== undefined && props.variant.qty === 0 ? "bg-disabledBtn" : "bg-review"}`}
          onClick={show_add_to_cart}
        >
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/cart-white.png"}
            alt="cart icon"
            quality={100}
            width={16}
            height={16}
          />
          <p>Thêm vào giỏ hàng</p>
        </button>
      </div>
      <RightSideDialog isVisible={promoteOpen} setIsVisible={setPromoteOpen} title={promoteTitle} content={promoteContent} />
      {videoUrl !== "" && (
        <VideoPlayer videoUrl={videoUrl} setVideoUrl={setVideoUrl} viewport={viewport} page_title={props.meta.title} page_path={`/product/${props.slug}`} />
      )}
    </>
  )
}

export default Detail
